import Team8 from './Team8'
export default Team8
